import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import detailsReducer from './detailsPage/data/reducer';
import detailsSagas from './detailsPage/data/sagas';
import listReducer from './listPage/data/reducer';
import listSagas from './listPage/data/sagas';
import routes from './routes';

const reducer = combineReducers({
  listPage: listReducer,
  detailsPage: detailsReducer,
});

const saga = function* () {
  yield all([listSagas(), detailsSagas()]);
};

export { reducer, saga, routes };
